import React from 'react';

const Characters = () => <section className="Characters">Characters Component</section>;

export default Characters;
